<template>
  <div id="app">
    <div class="main">
      <img src="@/assets/bg.jpg" alt="" class="bg">
      <img src="@/assets/play.png" alt="" class="play" @click="play = true">
      <div class="bottom-wrapper">
        <div class="btn-wrapper">
          <a href="https://www.taptap.cn/app/559118?utm_medium=rep&utm_source=rep_1tbtakusgzd" target="_blank"><img src="@/assets/taptap.png" class="btn" alt=""></a> 
          <img src="@/assets/android.png" class="btn" alt="" @click="onClickDownload()"> 
          <img src="@/assets/ios.png" class="btn" alt="" @click="onClickDownload()">
        </div>
      </div>
      <div class="desc-box" v-if="play">
        <div class="close" @click="play = false">x</div>
        <video class="desc" autoplay controls>
          <source src="@/assets/video.mp4">
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      play: false
    }
  },
  methods: {
    awakeGroup() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        console.log('ios')
        window.location.href ="mqqapi://card/show_pslcard?src_type=internal&version=1&uin=496413379&key=821f1738550176237fd7cc9012e6ea223abc99daff8bcb3f5d8362c74ab7da1e&card_type=group&source=external";
      } else if (/(Android)/i.test(navigator.userAgent)) {
        console.log('android')
        window.location.href ="mqqopensdkapi://bizAgent/qm/qr?url=http%3A%2F%2Fqm.qq.com%2Fcgi-bin%2Fqm%2Fqr%3Ffrom%3Dapp%26p%3Dandroid%26k%3D3CLB9TY0erPs2TjMn7bbAxvFetZiDKV9";
      } else {
        console.log('pc')
      }
    },

    onClickDownload() {
      alert('暂无安装包可下载')
    }
  },
   
}
</script>
<style lang="stylus">
@keyframes my-scale {
  50% {
    transform scale(.9)
  }
}

html, body
  padding 0 !important
  margin 0 !important

#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  position relative

  .main
    display flex
    justify-content center
    align-items center
    position relative
    width 100vw
    height 100vh
    margin 0 auto

    .bg
      width 100%
      height 100%

    .play
      position absolute
      width 1.45rem
      height 1.45rem
      animation my-scale 1.5s ease-in-out infinite

    .qq
      position absolute
      width 2.18rem
      height 1.97rem
      right 0
      top 50%
      transform translateY(-85%)

    .bottom-wrapper
      display flex
      justify-content center
      align-items center
      position absolute
      bottom 0
      width 100%

      .btn-wrapper
        display flex
        justify-content center
        align-items center
        flex-direction row
        bottom 0
        
        .btn
          width 5rem
          height 1.38rem
          margin .2rem 0

      .hr
        width .02rem
        height 3.21rem
        margin 0 .5rem

      .qr
        width 2.41rem
        height 3.23rem
    .desc-box
      position fixed
      left 0
      top 0
      right 0
      bottom 0
      background rgba(0, 0, 0, .8)
      z-index 9999999

      .close
        position absolute
        color #fff
        width .3rem
        height .6rem
        font-size .8rem
        right .8rem
        top 50%
        margin-top -3rem

      .desc
        position absolute
        left 50%
        top 50%
        transform translate(-50%, -50%)
        width 8rem
</style>
